// ** React Import
import { Link } from 'react-router-dom';

// ** Custom Components
import Sidebar from '@components/sidebar';
import Avatar from '@components/avatar';

// ** Third Party Components
import moment from 'moment';

// ** Reactstrap Imports
import { Label, Row, Col } from 'reactstrap';

const FeedbackSidebar = ({ open, toggleSidebar, selectedFeedback }) => {
    // ** States
    const handleSidebarClosed = () => { };

    if (!selectedFeedback) return null;

    const renderClient = () => {
        return (
            <Avatar
                initials
                className="me-1"
                color={'light-primary'}
                content={selectedFeedback.user?.fullName || ''}
                size="lg"
            />
        );
    };

    return (
        <Sidebar
            size="lg"
            open={open}
            title="Detalle del Comentario"
            headerClassName="mb-1"
            contentClassName="pt-0"
            toggleSidebar={toggleSidebar}
            onClosed={handleSidebarClosed}
        >
            <div className="mb-2">
                <Label className="form-label fw-bold">Usuario</Label>
                <div className="d-flex justify-content-start align-items-center">
                    {renderClient()}
                    <div className="d-flex flex-column">
                        <Link
                            to={`/users/view/${selectedFeedback.user?._id}`}
                            className="user_name text-truncate text-body"
                        >
                            <span className="fw-bolder">
                                {selectedFeedback.user?.fullName || 'No completado'}
                            </span>
                        </Link>
                        <small className="text-truncate text-muted mb-0">
                            {selectedFeedback.user?.email}
                        </small>
                    </div>
                </div>
            </div>

            <div className="mb-2">
                <Label className="form-label fw-bold">Fecha</Label>
                <div>
                    <span>
                        {moment(selectedFeedback.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                    </span>
                </div>
            </div>

            <div className="mb-2">
                <Label className="form-label fw-bold">Comentario</Label>
                <div
                    style={{
                        padding: '12px',
                        backgroundColor: '#f8f8f8',
                        borderRadius: '8px',
                        border: '1px solid #e0e0e0',
                        minHeight: '200px',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                    }}
                >
                    {selectedFeedback.feedback}
                </div>
            </div>

        </Sidebar>
    );
};

export default FeedbackSidebar;
